import e from "./Placeholder.vue2.mjs";
import { openBlock as r, createElementBlock as o, createElementVNode as t } from "vue";
import n from "../../_virtual/_plugin-vue_export-helper.mjs";
const c = {
  class: "w-full rounded border-2 border-dashed border-zinc-300 bg-transparent text-zinc-200 dark:border-zinc-700 dark:text-zinc-700",
  preserveAspectRatio: "none",
  stroke: "currentColor",
  fill: "none",
  viewBox: "0 0 200 200",
  "aria-hidden": "true"
}, s = /* @__PURE__ */ t("path", {
  "vector-effect": "non-scaling-stroke",
  "stroke-width": "2",
  d: "M0 0l200 200M0 200L200 0"
}, null, -1), d = [
  s
];
function a(i, l, p, _, f, h) {
  return r(), o("svg", c, d);
}
const x = /* @__PURE__ */ n(e, [["render", a]]);
export {
  x as default
};
//# sourceMappingURL=Placeholder.vue.mjs.map
